/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useRef, useState} from 'react';
import DisplayTime from "../DateTime/DisplayTime.jsx";
import ButtonComponent from "../BasicInputs/ButtonComponent.jsx";
import {CurrentUser, Sessions} from "authClient";

function UserSessions() {
    const [sessions, setSessions] = useState([]);
    const [currentSessionId, setCurrentSessionId] = useState(null);
    const intervalRef = useRef(null);

    const fetchData = async () => {
        try {
            const userInfo = await CurrentUser.getUserInfo();
            const sessionsData = await Sessions.list(userInfo.userId);
            setSessions(sessionsData?.result ?? []);
            setCurrentSessionId(userInfo.sessionId);
        } catch (error) {
            console.error('Error fetching session data:', error);
        }
    };

    useEffect(() => {
        fetchData();

        intervalRef.current = setInterval(() => {
            fetchData();
        }, 30000); // 30 seconds in milliseconds

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const handleCloseSession = async (sessionIndexKey, isCurrent) => {
        try {
            await Sessions.close(sessionIndexKey);
            await fetchData();
            if (isCurrent) {
                await CurrentUser.logout();
            }
        } catch (error) {
            console.error('Error closing session:', error);
        }
    };

    return (
        <>
            <div className={"p-1 space-y-2"}>
                {sessions.map(session => {
                    const isCurrent = session.indexKey === currentSessionId;
                    return (
                        <div
                            key={session.indexKey}
                            className={`p-2 border rounded-md flex ${isCurrent && "border-blue-300"}`}
                        >
                            <div className={"grow"}>
                                <div className={"font-semibold"}>
                                    {session.deviceName}{isCurrent && (" (Current Session)")}
                                </div>
                                <p className={"flex text-xs mt-2"}>
                                    <span className={"w-44"}>
                                        Last Used: <DisplayTime value={session.lastUsed}/>
                                    </span>
                                    <span className={"w-44"}>
                                        Logged in <DisplayTime value={session.creationTime}/>
                                    </span>
                                </p>
                            </div>

                            <ButtonComponent
                                iconName={"PiSignOut"}
                                text={"Close Session"}
                                onClick={() => handleCloseSession(session.indexKey, isCurrent)}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}


export default UserSessions;